import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {HttpClientJsonpModule, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import {CookieService} from 'ngx-cookie-service';
import {NgxCaptchaModule} from 'ngx-captcha';
import {NgcCookieConsentModule} from 'ngx-cookieconsent';
import {NgxMaskModule} from 'ngx-mask';
import {PdfViewerModule} from 'ng2-pdf-viewer';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from './shared/shared.module';

import {GoogleAnalyticsService} from './core/services/google-analytics.service';

import {cookieConfig} from './app.cookie.constant';
import {PagesModule} from './pages/pages.module';
import {ViewsModule} from './views/views.module';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule.withServerTransition({ appId: 'app-montreal' }),
    BrowserAnimationsModule,
    HttpClientJsonpModule,
    HttpClientModule,
    NgxCaptchaModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
    NgxMaskModule.forRoot(),
    PagesModule,
    ViewsModule,
    PdfViewerModule,
    ReactiveFormsModule,
    SharedModule.forRoot(),
  ],
  bootstrap: [AppComponent],
  providers: [
      GoogleAnalyticsService,
      CookieService
  ],
})
export class AppModule { }
